module.exports = __webpack_public_path__ + "static/media/fontext_1.7e3e011e.ico";